"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Item = _interopRequireDefault(require("./component/Item"));

var _SearchInput = _interopRequireDefault(require("../SearchInput"));

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);
/**
 * Menu component that renders list of clickable / selectable items
 */

var Menu = function Menu(_ref) {
  var _React$Children$map;

  var id = _ref.id,
      className = _ref.className,
      menuClassName = _ref.menuClassName,
      children = _ref.children,
      onItemClick = _ref.onItemClick,
      searchable = _ref.searchable,
      _ref$searchPlaceholde = _ref.searchPlaceholder,
      searchPlaceholder = _ref$searchPlaceholde === void 0 ? 'Search' : _ref$searchPlaceholde,
      disableSeachInput = _ref.disableSeachInput,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["id", "className", "menuClassName", "children", "onItemClick", "searchable", "searchPlaceholder", "disableSeachInput"]);
  var classes = useStyles();

  var _React$useState = _react["default"].useState(''),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      searchTerm = _React$useState2[0],
      setSearchTerm = _React$useState2[1];

  var _searchItems = function _searchItems(_ref2) {
    var target = _ref2.target;
    setSearchTerm(target.value);
  };

  var _clearSearch = function _clearSearch() {
    setSearchTerm('');
  };

  var _renderItem = function _renderItem(item) {
    if (item && _react["default"].isValidElement(item) && onItemClick) {
      return _react["default"].cloneElement(item, {
        onClick: function onClick(event) {
          var _item$props$onClick, _item$props;

          onItemClick(item);
          (_item$props$onClick = (_item$props = item.props).onClick) === null || _item$props$onClick === void 0 ? void 0 : _item$props$onClick.call(_item$props, event);
        }
      });
    }

    return item;
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.Menu),
    "data-test-id": "menu-".concat(id)
  }, searchable && /*#__PURE__*/_react["default"].createElement(_SearchInput["default"], {
    className: 'menu-searchbox',
    value: searchTerm,
    placeholder: searchPlaceholder,
    clearInput: _clearSearch,
    disabled: disableSeachInput,
    onChange: _searchItems,
    "data-test-id": "".concat(id, "-search-box"),
    clearSearchDataTestId: "".concat(id, "-search-box-clear"),
    searchInputDataTestId: "".concat(id, "-search-box")
  }), /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({
    id: id,
    className: (0, _classnames["default"])(className, menuClassName),
    "data-test-id": id
  }, rest), (_React$Children$map = _react["default"].Children.map(children, _renderItem)) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.filter(function (child) {
    if (searchable && searchTerm.length) {
      if ((0, _typeof2["default"])(child.props.children) == 'object') {
        return false;
      } else if (typeof child.props.children == 'string') {
        return child.props.children.toLowerCase().includes(searchTerm.toLowerCase());
      }
    }

    return true;
  })));
};

Menu.Item = _Item["default"];
var _default = Menu;
exports["default"] = _default;
//# sourceMappingURL=index.js.map